export default "__VITE_ASSET__DCgjWKGw__"